import { createSelector } from 'reselect';
import { makeSelectShelvesSelectedLastHistory } from '../../../../Configurator/selectors/history';
import { MINIMUM_LARGE_DOORS_HEIGHT } from '../../../../../lib/modelBuilder/constants';

export const makeSelectCanRemoveRods = () =>
  createSelector(makeSelectShelvesSelectedLastHistory(), (shelves): boolean => {
    if (shelves.length === 0) return false;
    for (const shelf of shelves) {
      if (shelf.rod) return true;
    }
    return false;
  });

export const makeSelectCanAddRods = () =>
  createSelector(makeSelectShelvesSelectedLastHistory(), (shelves): boolean => {
    if (shelves.length === 0) return false;
    let hasBigShelf = false;
    for (const shelf of shelves) {
      if (shelf.height >= MINIMUM_LARGE_DOORS_HEIGHT) {
        hasBigShelf = true;
        if (shelf.rod) return false;
      }
    }
    return hasBigShelf;
  });
